import { IS_AFTERPAY_ENABLED } from 'constants/afterPay';
import Image from "next/legacy/image";
import { useRouter } from 'next/router';
import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import AfterPayModal from './AfterPayModal';
import { InfoIcon, afterPayLogo } from 'constants/staticImage';


export default function AfterPayInfo({ total }: { total: any }) {
    const [openModal, setOpenModal] = useState(false);
    const bagItems = useSelector((state: RootState) => state.bagEvent.bag);
    const router = useRouter();

    const IsBelow = useMemo(() => {
        if (bagItems.total >= 250) {
            return true;
        }
        if (total >= 250) {
            return true;
        }

        return false;
    }, [bagItems, total]);

    const showPrice = useMemo(() => {
        if (bagItems.total >= 250) {
            return Number(bagItems.total / 4).toFixed(2);
        }
        if (total >= 250) {
            return Number(total / 4).toFixed(2);
        }

        return 0;
    }, [bagItems, total]);

    return (
        <>
            {IS_AFTERPAY_ENABLED(router.locale) ? (<>
                <div className='md:mt-[10px] xsm:mt-[5px] flex items-center justify-start'>
                    {IsBelow ? (
                        <p className='text-[12px] mt-[-4px]'>4 interest-free installments of <span className='font-medium'>${showPrice}</span></p>
                    ) : (
                        <p className='text-[12px] mt-[-4px]'>4 installments for orders $250 or above</p>
                    )}
                    <div className='ml-[7px] flex items-center justify-start'>
                        <Image
                            src={afterPayLogo}
                            unoptimized={true}
                            alt="after pay logo"
                            objectFit="cover"
                            width={75}
                            height={26}
                        />
                    </div>
                    <div className='cursor-pointer mt-[5px] ml-[7px]' onClick={() => {
                        setOpenModal(true);
                    }}>
                        <Image
                            src={InfoIcon}
                            unoptimized={true}
                            alt="after pay info"
                            objectFit="contain"
                            width={21}
                            height={20}
                        />
                    </div>
                </div>
                <AfterPayModal openModal={openModal} setOpenModal={setOpenModal}></AfterPayModal>
            </>) : (<></>)}
        </>
    );
}